import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LangProvider } from './i18n';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BranchesPage from './pages/BranchesPage';
import CustomersPage from './pages/CustomersPage';
import VendorsPage from './pages/VendorsPage';
import ProductsPage from './pages/ProductsPage';
import MasterDataPage from './pages/MasterDataPage';
import InventoryPage from './pages/InventoryPage';
import OrdersPage from './pages/OrdersPage';
import InvoicesPage from './pages/InvoicesPage';
import PosPage from './pages/PosPage';
import PosSessionsPage from './pages/PosSessionsPage';
import ItemCommissionsPage from './pages/ItemCommissionsPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import PaymentsPage from './pages/PaymentsPage';
import CurrenciesPage from './pages/CurrenciesPage';
import ReportsPage from './pages/ReportsPage';
import EMenuPage from './pages/EMenuPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import StockTransferPage from './pages/StockTransferPage';
import ExpensesPage from './pages/ExpensesPage';
import { NoAccess } from './components/common';
import './styles/global.css';

const P = ({ children, perm }) => {
  const { isAuthenticated, loading, hasPermission } = useAuth();
  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#8891a8' }}>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (perm && !hasPermission(perm)) return <NoAccess />;
  return children;
};
const Pub = ({ children }) => { const { isAuthenticated, loading } = useAuth(); if (loading) return null; if (isAuthenticated) return <Navigate to="/" />; return children; };

export default function App() {
  return (
    <LangProvider>
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ style: { background: '#191d27', color: '#e4e7ef', border: '1px solid #262c3a', fontSize: 13 }, success: { iconTheme: { primary: '#22c55e', secondary: '#191d27' } }, error: { iconTheme: { primary: '#ef4444', secondary: '#191d27' } } }} />
          <Routes>
            {/* Public e-Menu — no auth required */}
            <Route path="/menu/:branchCode" element={<EMenuPage />} />

            <Route path="/login" element={<Pub><LoginPage /></Pub>} />
            <Route path="/" element={<P><AppLayout /></P>}>
              <Route index element={<P perm="dashboard.view"><DashboardPage /></P>} />
              <Route path="branches" element={<P perm="branches.view"><BranchesPage /></P>} />
              <Route path="customers" element={<P perm="customers.view"><CustomersPage /></P>} />
              <Route path="vendors" element={<P perm="vendors.view"><VendorsPage /></P>} />
              <Route path="products" element={<P perm="products.view"><ProductsPage /></P>} />
              <Route path="master-data" element={<P perm="categories.manage"><MasterDataPage /></P>} />
              <Route path="inventory" element={<P perm="inventory.view"><InventoryPage /></P>} />
              <Route path="orders" element={<P perm="orders.view"><OrdersPage /></P>} />
              <Route path="purchase-orders" element={<P perm="purchase_orders.view"><PurchaseOrdersPage /></P>} />
              <Route path="stock-transfers" element={<P perm="stock_transfers.view"><StockTransferPage /></P>} />
              <Route path="invoices" element={<P perm="invoices.view"><InvoicesPage /></P>} />
              <Route path="pos" element={<P perm="pos.access"><PosPage /></P>} />
              <Route path="pos-sessions" element={<P perm="pos.access"><PosSessionsPage /></P>} />
              <Route path="item-commissions" element={<P perm="item_commissions.view_own"><ItemCommissionsPage /></P>} />
              <Route path="users" element={<P perm="users.view"><UsersPage /></P>} />
              <Route path="settings" element={<P perm="settings.view"><SettingsPage /></P>} />
              <Route path="payments" element={<P perm="payments.view"><PaymentsPage /></P>} />
              <Route path="currencies" element={<P perm="currency.manage"><CurrenciesPage /></P>} />
              <Route path="expenses" element={<P perm="expenses.view"><ExpensesPage /></P>} />
              <Route path="reports" element={<P perm="reports.sales"><ReportsPage /></P>} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </ThemeProvider>
    </LangProvider>
  );
}
